/**
 * @generated SignedSource<<9b094bbcdda2f46307c7cfbcad678225>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PersistentInviteEligibleQuery_license$data = {
  readonly licenseConsumingUserCount: number;
  readonly trialEndDate: string | null;
  readonly " $fragmentType": "PersistentInviteEligibleQuery_license";
};
export type PersistentInviteEligibleQuery_license$key = {
  readonly " $data"?: PersistentInviteEligibleQuery_license$data;
  readonly " $fragmentSpreads": FragmentRefs<"PersistentInviteEligibleQuery_license">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "PersistentInviteEligibleQuery_license",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "licenseConsumingUserCount"
    },
    {
      "kind": "ScalarField",
      "name": "trialEndDate"
    }
  ],
  "type": "License"
};

(node as any).hash = "8efb7d4229974be7992fd55823652fe0";

export default node;
